import React from 'react';
import { Link } from 'react-router-dom';

const AIMemory: React.FC = () => {
    return (
        <main id="main-content" className="w-full bg-canvas" role="main">
            {/* Page Title */}
            <section className="pt-32 pb-16 px-6 md:px-16 lg:px-24 text-center">
                <h1>AI Memory</h1>
            </section>

            {/* Content */}
            <section className="pb-[191px] px-6 md:px-12 lg:px-24">
                <div className="max-w-2xl mx-auto px-6 space-y-8 text-left">
                    <p className="text-balance leading-relaxed">
                        AI memory is one of the core research domains of SilentLabs.
                    </p>
                    <p className="text-balance leading-relaxed">
                        We are working on architectures for persistent memory — systems that remember indefinitely and adapt based on accumulated information. Our goal is an AI system that remembers clearly and seamlessly integrates relevant knowledge into every interaction.
                    </p>
                    <Link
                        to="/research"
                        className="inline-flex items-center justify-center rounded-full border border-white/20 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-white/10 mt-8"
                    >
                        Back to Research
                    </Link>
                </div>
            </section>
        </main>
    );
};

export default AIMemory;
